import { Platform } from "react-native"

/** Le web (navigateur), lu une fois au chargement : la plateforme ne change pas en cours de route. */
export const IS_WEB = Platform.OS === "web"
